import { render, staticRenderFns } from "./TotalSalesCard.vue?vue&type=template&id=5a2f7865"
import script from "./TotalSalesCard.vue?vue&type=script&lang=js"
export * from "./TotalSalesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a2f7865')) {
      api.createRecord('5a2f7865', component.options)
    } else {
      api.reload('5a2f7865', component.options)
    }
    module.hot.accept("./TotalSalesCard.vue?vue&type=template&id=5a2f7865", function () {
      api.rerender('5a2f7865', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Sales/components/TotalSalesCard.vue"
export default component.exports